import van from "vanjs-core";
import {Footer} from "./page3/footer";
import {MainContent} from "./page3/main-content";
import {Header} from "./page3/header";

const {div} = van.tags;

// 3. obrazovka
export const Page3 = () => {
    return div({class: 'bg-primary w-100 d-flex flex-column min-h-100-v'},
        Header,
        MainContent,
        Footer
    );
};